import React from 'react';
import { P } from '@osmosis/tailwind-ui/components/Text';

type Props = {
  text: string;
  searchText: string;
};

const Span = ({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}) => <span className={className}>{children}</span>;

/** AutocompleteRow. */
const AutocompleteRow = (props: Props) => {
  const { text, searchText } = props;
  const searchIndex = text?.toLowerCase()?.indexOf(searchText?.toLowerCase());

  const initial = text.substring(0, searchIndex);
  const middle = text.substring(searchIndex, searchIndex + searchText.length);
  const end = text.substring(searchIndex + searchText.length);

  if (searchIndex !== -1) {
    return (
      <P>
        <Span>
          {initial}
          <b>{middle}</b>
          {end}
        </Span>
      </P>
    );
  }

  return <Span>{text}</Span>;
};

export default AutocompleteRow;
